/**
 * MANAGED QUERY PARAMETER SUBSTITUTION CODES
 */

export const QP_SUBST_CHAR = ':'

export const SUBST_REQUIRED_ANCESTOR_ID = `${QP_SUBST_CHAR}requiredAncestorId${QP_SUBST_CHAR}`
export const SUBST_DATE_RANGE_TYPE = `${QP_SUBST_CHAR}dateRangeType${QP_SUBST_CHAR}`
export const SUBST_WIDGET_ID = `${QP_SUBST_CHAR}widgetId${QP_SUBST_CHAR}`

export const ALL_QUERY_PARAMETER_SUBST_TYPES = [
  SUBST_DATE_RANGE_TYPE, // which date range (primary/comparison?)
  SUBST_REQUIRED_ANCESTOR_ID, // if non-empty, then a particular widget ancestor is required
  SUBST_WIDGET_ID // which widget (for widget-specific parameters)
]

// date range types
export const DATE_RANGE_TYPE_PRIMARY = 0
export const DATE_RANGE_TYPE_COMPARISON = 1

/**
 * MANAGED QUERY PARAMETER TYPES
 */

// global query parameters
export const QP_DATE_START = `d${SUBST_DATE_RANGE_TYPE}0`
export const QP_DATE_END = `d${SUBST_DATE_RANGE_TYPE}1`
export const QP_FILTERS = 'filters'

export const GLOBAL_QUERY_PARAMETERS = [QP_DATE_START, QP_DATE_END, QP_FILTERS]

// widget-specific query parameters
const SUBST_WIDGET_ID_PAIR = SUBST_REQUIRED_ANCESTOR_ID + SUBST_WIDGET_ID
export const QP_CHART_VISUALIZATION = `chart_visualization_${SUBST_WIDGET_ID_PAIR}`
export const QP_COLUMN_FILTERS = `column_filters_${SUBST_WIDGET_ID_PAIR}`
export const QP_COLUMN_SET = `columns_${SUBST_WIDGET_ID_PAIR}`
export const QP_COLUMN_WIDTHS = `column_widths_${SUBST_WIDGET_ID_PAIR}`
export const QP_FOCUS_TAB = `tab_${SUBST_WIDGET_ID_PAIR}`
export const QP_FOCUS_PANEL = `panel_${SUBST_WIDGET_ID_PAIR}`
export const QP_MAP_OPTION = `map_option_${SUBST_WIDGET_ID_PAIR}`
export const QP_MAP_DEALER_MARKERS = `map_dealer_markers_${SUBST_WIDGET_ID_PAIR}`
export const QP_MAP_DEALER_MARKERS_TOGGLE = `map_dealer_markers_toggle_${SUBST_WIDGET_ID_PAIR}`
export const QP_MAP_OVERLAY = `map_overlay_${SUBST_WIDGET_ID_PAIR}`
export const QP_MAP_STATE = `map_state_${SUBST_WIDGET_ID_PAIR}`
export const QP_METRICS = `metrics_${SUBST_WIDGET_ID_PAIR}`
export const QP_START_AT = `start_at_${SUBST_WIDGET_ID_PAIR}`
export const QP_SORT_COLUMN = `sort_${SUBST_WIDGET_ID_PAIR}`
export const QP_MINIMIZED = `minimized_${SUBST_WIDGET_ID_PAIR}`
export const QP_TAKEOVER = `takeover`
export const QP_COMPARISON_SORT_COLUMN = `comparison_sort_${SUBST_WIDGET_ID_PAIR}`
export const QP_TIMELINE_EXPANDED_EVENTS = `expanded_events_${SUBST_WIDGET_ID_PAIR}`
export const QP_TIMELINE_HORIZONTAL_SCROLL = `horizontal_scroll_${SUBST_WIDGET_ID_PAIR}`
export const QP_SEARCH = `search_${SUBST_WIDGET_ID_PAIR}`
export const QP_PAGE = `page_${SUBST_WIDGET_ID_PAIR}`

// flyout-specific query parameters
export const QP_FLYOUT = 'flyoutState'

// Don't forget to add any query parameters you want managed for you to the array below. If you don't,
// you'll find that you'll be getting unexpected results in the query parameters of your URL.
export const ALL_MANAGED_QUERY_PARAMETERS = [
  QP_CHART_VISUALIZATION,
  QP_COLUMN_FILTERS,
  QP_COLUMN_SET,
  QP_DATE_START,
  QP_DATE_END,
  QP_FILTERS,
  QP_MINIMIZED,
  QP_FOCUS_TAB,
  QP_FOCUS_PANEL,
  QP_MAP_OPTION,
  QP_MAP_DEALER_MARKERS,
  QP_MAP_DEALER_MARKERS_TOGGLE,
  QP_MAP_OVERLAY,
  QP_MAP_STATE,
  QP_METRICS,
  QP_START_AT,
  QP_SORT_COLUMN,
  QP_TAKEOVER,
  QP_COMPARISON_SORT_COLUMN,
  QP_FLYOUT,
  QP_TIMELINE_EXPANDED_EVENTS,
  QP_TIMELINE_HORIZONTAL_SCROLL,
  QP_SEARCH,
  QP_PAGE,
  QP_COLUMN_WIDTHS
]

export const QP_PRIMARY_DATE_START = QP_DATE_START.replace(
  SUBST_DATE_RANGE_TYPE,
  DATE_RANGE_TYPE_PRIMARY
)
export const QP_PRIMARY_DATE_END = QP_DATE_END.replace(
  SUBST_DATE_RANGE_TYPE,
  DATE_RANGE_TYPE_PRIMARY
)
export const QP_COMPARISON_DATE_START = QP_DATE_START.replace(
  SUBST_DATE_RANGE_TYPE,
  DATE_RANGE_TYPE_COMPARISON
)
export const QP_COMPARISON_DATE_END = QP_DATE_END.replace(
  SUBST_DATE_RANGE_TYPE,
  DATE_RANGE_TYPE_COMPARISON
)

export const ALL_MANAGED_DATE_PARAMETERS = [
  [QP_PRIMARY_DATE_START, QP_PRIMARY_DATE_END],
  [QP_COMPARISON_DATE_START, QP_COMPARISON_DATE_END]
]

export const ALL_PURE_INSIGHTS_SUPPORTED_GLOBAL_PARAMETERS = [
  QP_PRIMARY_DATE_START,
  QP_PRIMARY_DATE_END,
  QP_COMPARISON_DATE_START,
  QP_COMPARISON_DATE_END,
  QP_FILTERS,
  QP_COLUMN_FILTERS,
  QP_COLUMN_WIDTHS
]

/**
 * MISC
 */

export const QP_DATE_FORMAT = 'MM-dd-yyyy'
